import SoftooMap from "../Map";
import Map from "ol/Map";
import { Point, LineString, Polygon, MultiPolygon } from "ol/geom";
import { Select } from "ol/interaction";

import { IModifiedFeature } from "../types";

import proj4 from "proj4";
proj4.defs([
  [ "EPSG:32647", "+proj=utm +zone=47 +datum=WGS84 +units=m +no_defs" ],
  [ "EPSG:32648", "+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs" ],
  [ "EPSG:4240",  "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=214,836,303,0,0,0,0 +no_defs" ],
  [ "EPSG:24047", "+proj=utm +zone=47 +a=6377276.345 +b=6356075.41314024 +towgs84=214,836,303,0,0,0,0 +units=m +no_defs" ],
  [ "EPSG:24048", "+proj=utm +zone=48 +a=6377276.345 +b=6356075.41314024 +towgs84=214,836,303,0,0,0,0 +units=m +no_defs" ]
]);
import { register } from "ol/proj/proj4";
register(proj4);

export class Indian75ToWgs84 extends Select {
  private $map: SoftooMap;
  private map: Map;
  private targets: IModifiedFeature[]; // the feature to be moved
  private select:Select;
  
  constructor(options) {
    options = options || {};
    let afterMoved;
    if (options.afterMoved) {
      afterMoved = options.afterMove;
      delete options.afterMove;
    }
    let pixelTolerance = 6;
    if (options.pixelTolerance) {
      pixelTolerance = options.pixelTolerance;
      delete options.pixelTolerance
    }
    let clickTolerance = Math.max(pixelTolerance-2, 4);
    
    super(Object.assign({
    }, options));
    
    this.select = <Select>this;
    this.selectFeature_ = (event) => {
      this.selectFeature(event);
    }
  }

  private selectFeature_;
  selectFeature(event) {
    let errNotSupported;
    if (event.selected && event.selected.length>0) {
      this.targets = event.selected.map((feature, index) => {
        /*let ctrUtm = this.$map.getFeatureCentroid(feature).utm;
        let zone = ctrUtm.zone;
        if (zone<47 || zone>48 || ctrUtm.NS!='N') {
          this.$map.$emit('error', {
            message: L('sOnlyUtmZone47And48InNorthAreSupported')
          });
          return;
        }*/
        let geom = feature.getGeometry();
        let coords = geom.getCoordinates();
        let epsg24047 = proj4.defs["EPSG:24047"],
            epsg24048 = proj4.defs["EPSG:24048"],
						//epsg32647 = proj4.defs["EPSG:32647"],
						//epsg32648 = proj4.defs["EPSG:32648"],
						//epsg4240 = proj4.defs["EPSG:4240"],
						epsg4326 = proj4.defs["EPSG:4326"],
            epsg3857 = proj4.defs["EPSG:3857"];
        let newCoords;    
        if (geom instanceof MultiPolygon) {
          newCoords = coords.map((polygon) => {
            return polygon.map((rings) => {
              return rings.map((coord) => {
                let c, utm;
                c = proj4(epsg3857, epsg4326, coord); // revert it back to original gcs
                utm = this.$map.lonLatToUtm(c);       // convert to utm
                if (utm.zone==47) {
                  c = proj4(epsg24047, epsg3857, [utm.x, utm.y]);
                } else if (utm.zone==48) {
                  c = proj4(epsg24048, epsg3857, [utm.x, utm.y]);
                } else {
                  errNotSupported = 'sSomePointsOutsideSupportedUtmZone';
                  c = coord;
                }
                return c;
              });
            });
          });
        } else if (geom instanceof Polygon) {
          newCoords = coords.map((rings) => {
            return rings.map((coord) => {
              let c, utm;
              c = proj4(epsg3857, epsg4326, coord); // revert it back to original gcs
              utm = this.$map.lonLatToUtm(c);       // convert to utm
              if (utm.zone==47) {
                c = proj4(epsg24047, epsg3857, [utm.x, utm.y]);
              } else if (utm.zone==48) {
                c = proj4(epsg24048, epsg3857, [utm.x, utm.y]);
              } else {
                errNotSupported = 'sSomePointsOutsideSupportedUtmZone';
                c = coord;
              }
              return c;
            });
          });
        } else if (geom instanceof LineString) {
          newCoords = coords.map((coord) => {
            let c, utm;
            c = proj4(epsg3857, epsg4326, coord); // revert it back to original gcs
            utm = this.$map.lonLatToUtm(c);       // convert to utm
            if (utm.zone==47) {
              c = proj4(epsg24047, epsg3857, [utm.x, utm.y]);
            } else if (utm.zone==48) {
              c = proj4(epsg24048, epsg3857, [utm.x, utm.y]);
            } else {
              errNotSupported = 'sSomePointsOutsideSupportedUtmZone';
              c = coord;
            }
            return c;
          });
        } else if (geom instanceof Point) {
          let c, utm;
          c = proj4(epsg3857, epsg4326, coords); // revert it back to original gcs
          utm = this.$map.lonLatToUtm(c);       // convert to utm
          if (utm.zone==47) {
            c = proj4(epsg24047, epsg3857, [utm.x, utm.y]);
          } else if (utm.zone==48) {
            c = proj4(epsg24048, epsg3857, [utm.x, utm.y]);
          } else {
            errNotSupported = 'sSomePointsOutsideSupportedUtmZone';
            c = coords;
          }
          newCoords = c;
        }
        let orgFeature = this.$map.cloneFeature(feature);
        geom.setCoordinates(newCoords);
        this.$map.addUndo(orgFeature, 'Update');
        feature.set('STATE', 'Update');
        return {
          original: orgFeature,
          modified: feature
        };
      });
      this.select.getOverlay().getSource().clear();
      this.$map.clearHighlightFeature();
      this.afterMoved(this.targets);
    }
  }
  
  afterMoved(moved:IModifiedFeature[]) {
    // to be override by application
  }

  setMap(map:Map) {
    if (map) {
      this.$map = map['SOFTOO_MAP'];
      this.map = map;
      this.select.on('select', this.selectFeature_);
      super.setMap(map);
    }
  }

  remove() {
    if (this.map) {
      this.targets = null;
      this.select.un('select', this.selectFeature_);
      this.select.getOverlay().getSource().clear();
      this.map.removeInteraction(this);
    }
  }
}